import {
  getRecommendedArtistAvailabilityLabel,
  getRecommendedArtistImageUrl,
  getRecommendedArtistMeta,
  getRecommendedArtistName,
} from '@/utils/aiRecommendedArtists';

export default function AiRecommendArtistCard({ artist, onClick, interactive = false }) {
  const name = getRecommendedArtistName(artist);
  const imageUrl = getRecommendedArtistImageUrl(artist);
  const meta = getRecommendedArtistMeta(artist);
  const availability = getRecommendedArtistAvailabilityLabel(artist);
  const Tag = interactive ? 'button' : 'div';

  return (
    <Tag
      type={interactive ? 'button' : undefined}
      className={`profile-view-ai__recommendation-card${interactive ? ' profile-view-ai__recommendation-card--interactive' : ''}`}
      onClick={interactive ? onClick : undefined}
    >
      <div className="profile-view-ai__recommendation-media">
        {imageUrl ? (
          <img
            className="profile-view-ai__recommendation-image"
            src={imageUrl}
            alt={name}
            loading="lazy"
          />
        ) : (
          <div className="profile-view-ai__recommendation-placeholder" aria-hidden="true" />
        )}
      </div>
      <div className="profile-view-ai__recommendation-body">
        <p className="profile-view-ai__recommendation-title">{name}</p>
        {meta ? <p className="profile-view-ai__recommendation-meta">{meta}</p> : null}
        {availability ? <p className="profile-view-ai__recommendation-availability">{availability}</p> : null}
      </div>
    </Tag>
  );
}
